import Component from './Pagination';
import ComponentContainer from './Pagination.container';
export default ComponentContainer(Component);
